import { Component, Input, OnInit } from '@angular/core';
import { GeometryObject } from 'geojson';
import { MarkerGeometry } from '~app/shared/map/map.service';
import { MapElement } from '../../shared/map/map-element.model';

@Component({
  selector: 'qm-element-hover',
  templateUrl: './element-hover.component.html',
  styleUrls: ['./element-hover.component.scss']
})
export class ElementHoverComponent {

  @Input()
  public selectedFeature: MapElement<MarkerGeometry>;

  constructor() { }

}
